// Castintech dashboard — Hermes (sohbet + yönetim), İKİ ROL + Yönetim sekmesi.
// Sohbet: /castintech-api/hermes-chat (operator|assistant persona, ayrı oturum).
// Yönetim: /castintech-api/hermes/info → model/provider, MCP araçları, hafıza (SOUL/USER/MEMORY), oturum.
// Tek Hermes / ortak beyin (castintech-hermes). render() idempotent: shell bir kez kurulur.
import { apiFetch } from '../api.js';
import { escHtml } from '../utils.js';

type Role = 'operator' | 'assistant';
type Tab = 'chat' | 'manage';
interface Msg { role: 'user' | 'hermes' | 'err'; text: string; }
const _msgs: Record<Role, Msg[]> = { operator: [], assistant: [] };
const _sid: Record<Role, string | null> = { operator: null, assistant: null };
let _role: Role = 'operator';
let _tab: Tab = 'chat';
let _built = false;
let _busy = false;
let _info: any = null;
let _infoLoading = false;

const GREETING: Record<Role, string> = {
  operator: 'Castintech ekosistem operatörü (propose-only). Müşteri/ürün/risk/governance sorularını sor — öneri üretirim, tek başıma uygulamam.',
  assistant: 'Kişisel asistanın. Planlama, araştırma, içerik/LinkedIn taslağı, web araması, özet — doğrudan yardımcı olurum. (Gönderme/paylaşım gibi işlerde önce onayını alırım.)',
};

export function renderHermesChat(): void {
  const root = document.getElementById('view-hermes');
  if (!root) return;
  if (!_built) { buildShell(root); _built = true; }
  if (_tab === 'chat') paintLog(); else paintManage();
}

function buildShell(root: HTMLElement): void {
  root.innerHTML = `
    <div class="hx-wrap">
      <div class="hx-tabs">
        <button class="hx-tab active" id="hx-tab-chat" type="button">💬 Sohbet</button>
        <button class="hx-tab" id="hx-tab-manage" type="button">⚙️ Yönetim</button>
      </div>
      <div class="hx-panel" id="hx-panel-chat">
        <div class="hx-head">
          <div class="hx-ava" id="hx-ava">🛰️</div>
          <div><div class="hx-title">Hermes</div><div class="hx-sub" id="hx-sub">Ekosistem operatörü · propose-only · GPT-5.5</div></div>
          <div class="hx-roles">
            <button class="hx-role active" id="hx-role-operator" type="button">🛰️ Operatör</button>
            <button class="hx-role" id="hx-role-assistant" type="button">🤝 Asistan</button>
          </div>
          <span class="hx-pill" id="hx-pill">hazır</span>
        </div>
        <div class="hx-log" id="hx-log"></div>
        <div class="hx-input">
          <textarea id="hx-text" rows="1" placeholder="Hermes'e sor… (Enter gönder, Shift+Enter yeni satır)"></textarea>
          <button class="hx-send" id="hx-send" type="button">Gönder</button>
        </div>
      </div>
      <div class="hx-panel" id="hx-panel-manage" style="display:none"><div class="hx-manage" id="hx-manage"></div></div>
    </div>`;
  const ta = root.querySelector<HTMLTextAreaElement>('#hx-text');
  const btn = root.querySelector<HTMLButtonElement>('#hx-send');
  if (btn) btn.addEventListener('click', () => void send());
  if (ta) {
    ta.addEventListener('keydown', (e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); void send(); } });
    ta.addEventListener('input', () => { ta.style.height = 'auto'; ta.style.height = Math.min(ta.scrollHeight, 140) + 'px'; });
  }
  root.querySelector('#hx-role-operator')?.addEventListener('click', () => setRole('operator'));
  root.querySelector('#hx-role-assistant')?.addEventListener('click', () => setRole('assistant'));
  root.querySelector('#hx-tab-chat')?.addEventListener('click', () => setTab('chat'));
  root.querySelector('#hx-tab-manage')?.addEventListener('click', () => setTab('manage'));
}

function setTab(t: Tab): void {
  _tab = t;
  document.getElementById('hx-tab-chat')?.classList.toggle('active', t === 'chat');
  document.getElementById('hx-tab-manage')?.classList.toggle('active', t === 'manage');
  const pc = document.getElementById('hx-panel-chat'); if (pc) pc.style.display = t === 'chat' ? '' : 'none';
  const pm = document.getElementById('hx-panel-manage'); if (pm) pm.style.display = t === 'manage' ? '' : 'none';
  if (t === 'manage') { if (!_info && !_infoLoading) void loadInfo(); else paintManage(); }
}

function setRole(r: Role): void {
  if (_busy || r === _role) return;
  _role = r;
  document.getElementById('hx-role-operator')?.classList.toggle('active', r === 'operator');
  document.getElementById('hx-role-assistant')?.classList.toggle('active', r === 'assistant');
  const ava = document.getElementById('hx-ava'); if (ava) ava.textContent = r === 'assistant' ? '🤝' : '🛰️';
  const sub = document.getElementById('hx-sub'); if (sub) sub.textContent = r === 'assistant' ? 'Kişisel asistan · geniş yetkili · GPT-5.5' : 'Ekosistem operatörü · propose-only · GPT-5.5';
  const wrap = document.querySelector('.hx-wrap'); if (wrap) wrap.classList.toggle('hx-assistant', r === 'assistant');
  paintLog();
}

function paintLog(pending = false): void {
  const log = document.getElementById('hx-log');
  if (!log) return;
  const msgs = _msgs[_role];
  const intro = msgs.length ? '' : `<div class="hx-msg hermes"><div class="hx-bubble">${escHtml(GREETING[_role])}</div></div>`;
  const items = msgs.map(m => `<div class="hx-msg ${m.role}"><div class="hx-bubble">${escHtml(m.text)}</div></div>`).join('');
  const wait = pending ? `<div class="hx-msg hermes"><div class="hx-bubble hx-typing"><span></span><span></span><span></span></div></div>` : '';
  log.innerHTML = intro + items + wait;
  log.scrollTop = log.scrollHeight;
  const pill = document.getElementById('hx-pill');
  if (pill) { pill.textContent = _busy ? 'düşünüyor…' : 'hazır'; pill.className = 'hx-pill' + (_busy ? ' busy' : ''); }
}

async function send(): Promise<void> {
  if (_busy) return;
  const ta = document.getElementById('hx-text') as HTMLTextAreaElement | null;
  const msg = (ta?.value || '').trim();
  if (!msg) return;
  if (ta) { ta.value = ''; ta.style.height = 'auto'; }
  const role = _role;
  _msgs[role].push({ role: 'user', text: msg });
  _busy = true; paintLog(true);
  try {
    const r = await apiFetch('/castintech-api/hermes-chat', {
      method: 'POST', headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ message: msg, sessionId: _sid[role], role }),
    });
    const j = await r.json().catch(() => ({ ok: false, error: 'geçersiz yanıt' }));
    if (j && j.ok) { _sid[role] = j.sessionId || _sid[role]; _msgs[role].push({ role: 'hermes', text: String(j.reply || '') }); }
    else _msgs[role].push({ role: 'err', text: 'Hermes yanıtı alınamadı: ' + (j?.error || r.status) });
  } catch (e) {
    _msgs[role].push({ role: 'err', text: 'Bağlantı hatası: ' + (e as Error).message });
  }
  _busy = false; paintLog();
}

async function loadInfo(): Promise<void> {
  _infoLoading = true; paintManage();
  try {
    const r = await apiFetch('/castintech-api/hermes/info');
    _info = await r.json().catch(() => ({ ok: false, error: 'geçersiz yanıt' }));
  } catch (e) { _info = { ok: false, error: (e as Error).message }; }
  _infoLoading = false; paintManage();
}

function memBlock(title: string, content: string): string {
  const c = (content || '').trim();
  const preview = c ? escHtml(c) : '<span style="color:var(--muted)">— boş —</span>';
  return `<details class="hx-mem"><summary>${escHtml(title)} <span class="hx-mem-n">${c.length} karakter</span></summary><pre class="hx-mem-pre">${preview}</pre></details>`;
}

// 2026-06-14 — Hermes governance paneli. notify /info'ya `governance` bloğu enrich eder
// (honest: mode propose_only, declaredCapabilities direct-ro/via-propose, forbidden hard-block).
// Sahte "active" YOK — read=salt-okur, action=council önerisi.
function pill(text: string, tone: 'green' | 'amber' | 'red' | 'gray'): string {
  const c = tone === 'green' ? '#1f4a2a;color:#9be8a8' : tone === 'amber' ? '#3a2a05;color:#fde047'
    : tone === 'red' ? '#4a1f1f;color:#f0a8a8' : '#2a2a2a;color:#94a3b8';
  return `<span style="display:inline-block;font-size:11px;padding:2px 8px;border-radius:10px;background:${c.split(';')[0]};color:${c.split('color:')[1]};font-weight:500;">${escHtml(text)}</span>`;
}

// gerçekleşme tipi → rozet (direct-ro = salt-okur erişim; via-propose = öneri, execute değil)
function realizationTag(v: string): string {
  if (v === 'direct-ro') return `<span class="hx-cap on">✓ salt-okur</span>`;
  if (v === 'via-propose') return `<span style="display:inline-block;font-size:11px;padding:2px 7px;border-radius:6px;background:#1e3a5f;color:#9bd0ff;font-weight:500;">↗ öneri (council)</span>`;
  return `<span class="hx-cap off">${escHtml(v)}</span>`;
}

function govSection(i: any): string {
  const g = i && i.governance;
  if (!g) {
    return `<div class="hx-m-sec"><div class="hx-m-title">🛡️ Governance & Yetki</div>
      <div style="padding:10px;background:var(--bg2,#0f1419);border-left:3px solid #94a3b8;border-radius:4px;font-size:13px;color:var(--muted);">
        Governance bilgisi alınamadı (notify enrichment yanıtı yok).
      </div></div>`;
  }
  const reachable = g.bridgeReachable === true;
  const caps = g.declaredCapabilities || {};
  const capRows = Object.entries(caps).map(([k, v]) =>
    `<div style="display:flex;justify-content:space-between;align-items:center;gap:8px;">
      <span>${escHtml(k)}</span>${realizationTag(String(v))}</div>`).join('') || '<span style="color:var(--muted)">—</span>';
  const forb = Array.isArray(g.forbidden) ? g.forbidden : [];
  const limRows = forb.map((k: string) => `<div class="hx-cap off">⛔ ${escHtml(k)}</div>`).join('') || '<span style="color:var(--muted)">—</span>';
  return `<div class="hx-m-sec"><div class="hx-m-title">🛡️ Governance & Yetki</div>
    <div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:8px;">
      ${pill('mode: ' + (g.mode || '?'), g.mode === 'propose_only' ? 'green' : 'amber')}
      ${pill(reachable ? 'bridge: erişilebilir' : 'bridge: ERİŞİLEMEZ', reachable ? 'green' : 'red')}
      ${pill('contract: ' + (g.infoContract || '?'), g.infoContract === 'full' ? 'green' : 'amber')}
    </div>
    <div style="font-size:12px;color:var(--muted);margin-bottom:10px;">
      <div><b style="color:var(--text)">Enforcement:</b> ${escHtml(String(g.enforcement || '—'))}</div>
      <div><b style="color:var(--text)">Capability source:</b> <code>${escHtml(String(g.capabilitySource || '—'))}</code></div>
      <div><b style="color:var(--text)">Outbox:</b> <code>${escHtml(String(g.outboxPath || '—'))}</code> · <b style="color:var(--text)">Image:</b> ${escHtml(String(g.bridgeImage || '—'))}</div>
    </div>
    <div style="display:grid;grid-template-columns:1.2fr 1fr;gap:14px;">
      <div><div class="hx-m-k" style="margin-bottom:4px;">Council-onaylı yetkiler (politika)</div><div style="display:flex;flex-direction:column;gap:4px;font-size:12px;">${capRows}</div></div>
      <div><div class="hx-m-k" style="margin-bottom:4px;">Yasaklı (hard-block, yapısal)</div><div style="display:flex;flex-direction:column;gap:3px;font-size:12px;">${limRows}</div></div>
    </div>
    ${g.infoContract === 'legacy' ? `<div style="margin-top:10px;padding:8px;background:var(--bg2,#0f1419);border-left:3px solid #fbbf24;border-radius:4px;font-size:12px;color:var(--muted);">
      🔶 <b style="color:var(--text)">Gerçek aktivasyon kısmi.</b> Hermes propose-only ZATEN canlı (chat + vault-read + propose-outbox→council). Eksik: bridge upstream framework <code>/info</code>'su governance contract dönmüyor (legacy) ve granular typed-flow (route-request vs audit-note) submitter'da tiplenmemiş. Yetki <b>EXECUTE değil</b> — read salt-okur, action council önerisi. Detay: wiki/decisions/2026-06-14-hermes-operator-authority-grant.md
    </div>` : ''}
    ${g.note ? `<div style="margin-top:8px;font-size:11px;color:var(--muted);">${escHtml(String(g.note))}</div>` : ''}
  </div>`;
}

function paintManage(): void {
  const el = document.getElementById('hx-manage');
  if (!el) return;
  if (_infoLoading) { el.innerHTML = '<div class="hx-m-load">Yükleniyor…</div>'; return; }
  if (!_info || !_info.ok) { el.innerHTML = `<div class="hx-m-load">Bilgi alınamadı: ${escHtml(_info?.error || '?')}</div><button class="hx-send" id="hx-info-retry" type="button">Tekrar dene</button>`; document.getElementById('hx-info-retry')?.addEventListener('click', () => void loadInfo()); return; }
  const i = _info;
  const mcp = (i.mcp || []).map((m: any) => `<span class="hx-tool ${m.enabled ? '' : 'off'}">${escHtml(m.name)}${m.command ? ` <span class="hx-tool-cmd">${escHtml(m.command)}</span>` : ''}${m.enabled ? '' : ' (kapalı)'}</span>`).join('') || '<span style="color:var(--muted)">— MCP aracı yok —</span>';
  el.innerHTML = `
    <div class="hx-m-row">
      <div class="hx-m-card"><div class="hx-m-k">Model</div><div class="hx-m-v">${escHtml(i.model || '—')}</div><div class="hx-m-sub">${escHtml(i.provider || '')}</div></div>
      <div class="hx-m-card"><div class="hx-m-k">Oturum</div><div class="hx-m-v">${i.sessions ?? 0}</div><div class="hx-m-sub">kayıtlı</div></div>
      <div class="hx-m-card"><div class="hx-m-k">MCP araçları</div><div class="hx-m-v">${(i.mcp || []).filter((m: any) => m.enabled).length}</div><div class="hx-m-sub">aktif</div></div>
    </div>
    ${govSection(i)}
    <div class="hx-m-sec"><div class="hx-m-title">🔌 Araçlar (MCP)</div><div class="hx-tools">${mcp}</div></div>
    <div class="hx-m-sec"><div class="hx-m-title">🧠 Hafıza <span class="hx-m-hint">(salt-okunur — düzenleme yakında)</span></div>
      ${memBlock('SOUL — persona', i.memory?.soul || '')}
      ${memBlock('USER — kullanıcı notları', i.memory?.user || '')}
      ${memBlock('MEMORY — ekosistem belleği', i.memory?.memory || '')}
    </div>
    <button class="hx-send" id="hx-info-refresh" type="button" style="margin-top:4px">↻ Yenile</button>`;
  document.getElementById('hx-info-refresh')?.addEventListener('click', () => void loadInfo());
}
